import { admission } from "../../../config/api";
import React from 'react'
import { Button } from 'evergreen-ui'
import { IoNewspaper } from 'react-icons/io5'
import { PrintRegist } from '../../../Components/AllowPermission'

const StatusManageRegist_1 = ({ DataRegister }) => {

  const validCodes = [
    "1101",
    "1102",
    "1103",
    "1106",
    "1110",
    "1207",
    "1208",
    "1301",
    "1302",
    "1304",
    "1310",
  ];
  return (
    <>
      <>

        {(DataRegister[0].REGISTER_TYPE_ID === "1" || DataRegister[0].REGISTER_TYPE_ID === "5") ?
          (
            <>
              {
                (
                  DataRegister[0].ROB_ID === "183" || DataRegister[0].ROB_ID === "184") ?
                  validCodes.includes(DataRegister[0].Major1_MAJOR_ID) ?
                    (
                      <Button
                        disabled={PrintRegist(DataRegister[0].ROB_ID, DataRegister[0].Major1_MAJOR_ID, DataRegister)}
                        iconBefore={<IoNewspaper />}
                        appearance="primary"
                        intent="success"
                        onClick={() => {
                          DataRegister[0].Major1_MAJOR_ID === "9902"
                            ? window.open(
                              admission + "/dashboard_printregistrar2018_nurse?code_test=" +
                              DataRegister[0].REGISTER_ID
                            )
                            : window.open(
                              admission + "/dashboard_printregistrar2022?code_test=" +
                              DataRegister[0].REGISTER_ID
                              //6411207001คือรหัสประจำตัวผู้สมัคร
                            );
                        }}
                      >
                        พิมพ์ใบสมัคร
                      </Button>
                    )
                    :


                    (<></>)

                  :
                  (
                    <>
                    { DataRegister[0].ROB_ID === "183" || DataRegister[0].ROB_ID === "184" || DataRegister[0].ROB_ID === "182" || DataRegister[0].ROB_ID === "179" || DataRegister[0].ROB_ID === "186" ? (
                       <Button
                        disabled={PrintRegist(DataRegister[0].ROB_ID, DataRegister[0].Major1_MAJOR_ID, DataRegister)}
                        iconBefore={<IoNewspaper />}
                        appearance="primary"
                        intent="success"
                        onClick={() => {
                          DataRegister[0].Major1_MAJOR_ID === "9902"
                            ? window.open(
                              admission + "/dashboard_printregistrar2018_nurse?code_test=" +
                              DataRegister[0].REGISTER_ID
                            )
                            : window.open(
                              admission + "/dashboard_printregistrar2022?code_test=" +
                              DataRegister[0].REGISTER_ID
                              //6411207001คือรหัสประจำตัวผู้สมัคร
                            );
                        }}
                      >
                        พิมพ์ใบสมัคร
                      </Button>

                    ) : (
                      <></>
                    )}
                     
                    </>
                  )
              }
            </>
          ) :   DataRegister[0].ROB_ID === "191" ? (
            <Button
             disabled={PrintRegist(DataRegister[0].ROB_ID, DataRegister[0].Major1_MAJOR_ID, DataRegister)}
             iconBefore={<IoNewspaper />}
             appearance="primary"
             intent="success"
             onClick={() => {
               DataRegister[0].Major1_MAJOR_ID === "9902"
                 ? window.open(
                   admission + "/dashboard_printregistrar2018_nurse?code_test=" +
                   DataRegister[0].REGISTER_ID
                 )
                 : window.open(
                   admission + "/dashboard_printregistrar2022?code_test=" +
                   DataRegister[0].REGISTER_ID
                   //6411207001คือรหัสประจำตัวผู้สมัคร
                 );
             }}
           >
             พิมพ์ใบสมัคร
             {DataRegister[0].ROB_ID}
           </Button>

         ) : (
           <Button
             disabled={PrintRegist(DataRegister[0].ROB_ID, DataRegister[0].Major1_MAJOR_ID, DataRegister)}
             iconBefore={<IoNewspaper />}
             appearance="primary"
             intent="success"
             onClick={() => {
               DataRegister[0].Major1_MAJOR_ID === "9902"
                 ? window.open(
                   admission + "/dashboard_printregistrar2018_nurse?code_test=" +
                   DataRegister[0].REGISTER_ID
                 )
                 : window.open(
                   admission + "/dashboard_printregistrar2022?code_test=" +
                   DataRegister[0].REGISTER_ID
                   //6411207001คือรหัสประจำตัวผู้สมัคร
                 );
             }}
           >
             พิมพ์ใบสมัคร
           </Button>
         )
        }
      </>
    </>
  )
}

export default StatusManageRegist_1